export default __webpack_public_path__ + "static/media/supljikvadar.5555dfb4.jpg";